import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import {Integrations} from '@sentry/tracing';

import * as serviceWorker from './serviceWorker';
import App from 'App';
import './index.module.css';
import FontManager from './components/LanguageSwitcher/FontManager';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://a170cb6663ed4fa1ba5dd6c2332c0612@o19398.ingest.sentry.io/5505717',
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
  ReactDOM.render(
    <>
      <FontManager />
      <App />
    </>,
    document.getElementById('root'),
  );
} else {
  ReactDOM.render(
    <React.StrictMode>
      <FontManager />
      <App />
    </React.StrictMode>,
    document.getElementById('root'),
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
